/**
 * Spring Bundle Promo - Brooklyn Bicycle Co.
 * Auto-adds Commuter Bundle + applies SPRING100 and SPRINGBUNDLE discount codes
 * for visitors arriving on a PDP from a Spring 2026 LP.
 *
 * Mirrors the architecture of lp-bundle-promo.js but for the Spring 2026 campaign.
 *
 * Flow:
 *  1. On Spring LP: stashes bbc_spring26 session flag (done by inline snippet)
 *  2. On Spring LP CTAs: rewrites /products/{handle} links to include ?promo=spring-bundle
 *  3. On PDP: detects ?promo=spring-bundle OR bbc_spring26 flag, intercepts ATC
 *  4. On ATC: adds Commuter Bundle to cart, applies SPRING100,SPRINGBUNDLE codes,
 *     dispatches ajaxProduct:added for cart drawer
 *  5. On cart page: removes bundle if no qualifying Spring bike present
 *  6. Injects "Included FREE with your [Bike]" note in cart drawer
 *  7. Hides the theme upsell card (the riding essentials upsell)
 *
 * Eligible bikes: lorimer, bedford-8, roebling, wythe, willow-8, driggs-8
 * Bundle variant: 40885522038864 ($54.99 - made $0 by SPRINGBUNDLE BXGY discount)
 */
(function () {
  'use strict';

  var SPRING_SESSION_KEY = 'bbc_spring26';
  var PROMO_KEY = 'spring_bundle_promo';
  var PROMO_VALUE = 'spring-bundle';
  var BUNDLE_VARIANT = 40885522038864;
  var DISCOUNT_CODES = 'SPRING100,SPRINGBUNDLE';
  var BIKE_HANDLES = ['lorimer', 'bedford-8', 'roebling', 'wythe', 'willow-8', 'driggs-8'];

  /* ---- Helpers ---- */

  function isOnSpringLP() {
    var p = window.location.pathname;
    return (
      p.indexOf('/collections/spring-lineup') === 0 ||
      p.indexOf('/collections/spring-models') === 0 ||
      p.indexOf('/pages/bikes-for-petite-riders') === 0 ||
      p.indexOf('/pages/premium-commuter-bikes') === 0 ||
      p.indexOf('/pages/pedal-commuter-vs-ebike') === 0 ||
      p.indexOf('/pages/bike-for-commute-and-fitness') === 0 ||
      p.indexOf('/pages/buy-and-ride-promise') === 0 ||
      p.indexOf('/pages/bikes-with-lifetime-warranty') === 0 ||
      p.indexOf('/pages/bikes-designed-in-brooklyn') === 0 ||
      p.indexOf('/pages/edited-commuter-lineup') === 0 ||
      p.indexOf('/pages/bike-customer-reviews') === 0
    );
  }

  function isOnPDP() {
    var p = window.location.pathname;
    for (var i = 0; i < BIKE_HANDLES.length; i++) {
      if (p.indexOf('/products/' + BIKE_HANDLES[i]) === 0) return true;
    }
    return false;
  }

  function isOnCart() {
    return window.location.pathname === '/cart';
  }

  function stashSpringFlag() {
    try { sessionStorage.setItem(SPRING_SESSION_KEY, 'true'); } catch (e) {}
  }

  function stashPromo() {
    try { sessionStorage.setItem(PROMO_KEY, PROMO_VALUE); } catch (e) {}
  }

  function hasSpringSession() {
    try {
      return sessionStorage.getItem(SPRING_SESSION_KEY) === 'true' ||
             sessionStorage.getItem(PROMO_KEY) === PROMO_VALUE;
    } catch (e) {}
    return false;
  }

  function clearPromo() {
    try {
      sessionStorage.removeItem(PROMO_KEY);
    } catch (e) {}
  }

  function addBundleApplyDiscountAndOpenDrawer(bikeProduct) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hasBundle = false;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].variant_id === BUNDLE_VARIANT) hasBundle = true;
        }
        if (hasBundle) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: bikeProduct || {} } }));
          return;
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: BUNDLE_VARIANT, quantity: 1 }] })
        })
        .then(function () {
          /* Apply BOTH discount codes via /cart/update.js (supports comma-separated codes) */
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ discount: 'SPRING100,SPRINGBUNDLE' })
          });
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: bikeProduct || {} } }));
        });
      })
      .catch(function () {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: bikeProduct || {} } }));
      });
  }

  window.__springBundlePromo = {
    hasSpringSession: hasSpringSession,
    addBundleApplyDiscountAndOpenDrawer: addBundleApplyDiscountAndOpenDrawer
  };

  /* ---- STEP 1: On Spring LP, tag bike links with promo + stash flag ---- */

  function tagSpringLPLinks() {
    var links = document.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href') || '';
      if (href.indexOf('promo=' + PROMO_VALUE) !== -1) continue;
      var isBike = false;
      for (var b = 0; b < BIKE_HANDLES.length; b++) {
        if (href.indexOf('/products/' + BIKE_HANDLES[b]) !== -1) { isBike = true; break; }
      }
      if (!isBike) continue;
      links[i].setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') + 'promo=' + PROMO_VALUE);
    }
  }

  /* ---- STEP 2: PDP - detect param OR Spring session, intercept ATC ---- */

  function pdpInit() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('promo') === PROMO_VALUE) {
      stashPromo();
    }
    var discountParam = params.get('discount') || '';
    if (discountParam.indexOf('SPRING') !== -1) {
      stashSpringFlag();
    }
    if (hasSpringSession()) {
      interceptATC();
    }
  }

  /* ---- STEP 3: ATC intercept (fetch + XHR) ---- */

  function interceptATC() {
    var origFetch = window.fetch;

    window.fetch = function () {
      var url = arguments[0];
      var opts = arguments[1] || {};
      var isCartAdd = (typeof url === 'string' && url.indexOf('/cart/add') !== -1);

      if (!isCartAdd || !hasSpringSession()) {
        return origFetch.apply(this, arguments);
      }

      var body = opts.body;
      if (body && typeof body === 'string' && body.indexOf(String(BUNDLE_VARIANT)) !== -1) {
        return origFetch.apply(this, arguments);
      }

      return origFetch.apply(this, arguments).then(function (response) {
        var cloned = response.clone();
        cloned.json().then(function (bikeProduct) {
          addBundleApplyDiscountAndOpenDrawer(bikeProduct);
        }).catch(function () {
          addBundleApplyDiscountAndOpenDrawer(null);
        });
        return response;
      });
    };

    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this._springUrl = url;
      return origOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (data) {
      var xhr = this;
      var url = xhr._springUrl || '';
      var isCartAdd = (typeof url === 'string' && url.indexOf('/cart/add') !== -1);

      if (!isCartAdd || !hasSpringSession()) {
        return origSend.apply(this, arguments);
      }
      if (data && typeof data === 'string' && data.indexOf(String(BUNDLE_VARIANT)) !== -1) {
        return origSend.apply(this, arguments);
      }

      var origOnLoad = xhr.onload;
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            var bikeProduct = JSON.parse(xhr.responseText);
            addBundleApplyDiscountAndOpenDrawer(bikeProduct);
          } catch (e) {
            addBundleApplyDiscountAndOpenDrawer(null);
          }
        }
        if (origOnLoad) origOnLoad.apply(xhr, arguments);
      };

      return origSend.apply(this, arguments);
    };
  }

  /* ---- STEP 4: Cart guard ---- */

  function cartGuard() {
    function checkAndClean() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var hasBike = false;
          var bundleQty = 0;
          for (var i = 0; i < cart.items.length; i++) {
            var item = cart.items[i];
            for (var b = 0; b < BIKE_HANDLES.length; b++) {
              if (item.handle === BIKE_HANDLES[b]) { hasBike = true; break; }
            }
            if (item.variant_id === BUNDLE_VARIANT || item.id === BUNDLE_VARIANT) {
              bundleQty = item.quantity;
            }
          }
          if (bundleQty > 0 && !hasBike) {
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ id: String(BUNDLE_VARIANT), quantity: 0 })
            }).then(function () { window.location.reload(); });
          } else if (bundleQty > 1) {
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ id: String(BUNDLE_VARIANT), quantity: 1 })
            }).then(function () { window.location.reload(); });
          }
        }).catch(function () {});
    }

    setTimeout(checkAndClean, 800);

    var origFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var isCartMod = (typeof url === 'string' &&
        (url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1));
      var result = origFetch.apply(this, arguments);
      if (isCartMod) {
        result.then(function (r) { setTimeout(checkAndClean, 600); return r; });
      }
      return result;
    };
  }

  /* ---- STEP 5: Cart drawer note + hide upsell ---- */

  var BUNDLE_NOTE_CLASS = 'spring-bundle-free-note';
  var BUNDLE_NOTE_STYLE = 'display:block;font-size:11px;color:#2c3c4c;font-weight:600;' +
    'margin-top:4px;padding:3px 8px;background:#f0ebe4;border-radius:3px;' +
    'line-height:1.3;letter-spacing:0.2px;';

  function getBikeNameFromDrawer() {
    var items = document.querySelectorAll('[data-products] .cart__item-name');
    for (var i = 0; i < items.length; i++) {
      var text = (items[i].textContent || '').toLowerCase();
      for (var b = 0; b < BIKE_HANDLES.length; b++) {
        if (text.indexOf(BIKE_HANDLES[b]) !== -1) {
          return BIKE_HANDLES[b].split('-').map(function(w) {
            return w.charAt(0).toUpperCase() + w.slice(1);
          }).join(' ');
        }
      }
    }
    return '';
  }

  function injectBundleNote() {
    var existing = document.querySelectorAll('.' + BUNDLE_NOTE_CLASS);
    for (var e = 0; e < existing.length; e++) {
      existing[e].parentNode.removeChild(existing[e]);
    }
    var nameLinks = document.querySelectorAll('[data-products] .cart__item-name');
    var bundleTitleEl = null;
    for (var i = 0; i < nameLinks.length; i++) {
      var text = (nameLinks[i].textContent || '').toLowerCase();
      if (text.indexOf('commuter bundle') !== -1 ||
          text.indexOf('riding essentials') !== -1 ||
          text.indexOf('commuter accessories') !== -1) {
        bundleTitleEl = nameLinks[i];
        break;
      }
    }
    if (!bundleTitleEl) return;
    var bikeName = getBikeNameFromDrawer();
    if (!bikeName) return;
    var titleWrap = bundleTitleEl.closest('.cart__item-title');
    if (!titleWrap) return;
    var note = document.createElement('span');
    note.className = BUNDLE_NOTE_CLASS;
    note.setAttribute('style', BUNDLE_NOTE_STYLE);
    note.textContent = 'Included FREE with your ' + bikeName;
    titleWrap.appendChild(note);

    /* Hide the theme upsell card (riding essentials, etc.) when Spring bundle is in cart */
    var upsellCards = document.querySelectorAll('cart-upsell, .upsell__container, [class*="upsell"]');
    for (var u = 0; u < upsellCards.length; u++) {
      upsellCards[u].style.display = 'none';
    }
  }

  function restoreUpsellIfNeeded() {
    var nameLinks = document.querySelectorAll('[data-products] .cart__item-name');
    var hasBundle = false;
    for (var i = 0; i < nameLinks.length; i++) {
      var text = (nameLinks[i].textContent || '').toLowerCase();
      if (text.indexOf('commuter bundle') !== -1) { hasBundle = true; break; }
    }
    if (!hasBundle) {
      var upsellCards = document.querySelectorAll('cart-upsell, .upsell__container');
      for (var u = 0; u < upsellCards.length; u++) {
        upsellCards[u].style.display = '';
      }
    }
  }

  function observeBundleNote() {
    var productsEl = document.querySelector('[data-products]');
    if (productsEl && !productsEl.__springBundleNoteObs) {
      productsEl.__springBundleNoteObs = true;
      new MutationObserver(function () {
        setTimeout(function () { injectBundleNote(); restoreUpsellIfNeeded(); }, 50);
      }).observe(productsEl, { childList: true, subtree: true });
    }
    var drawer = document.getElementById('CartDrawer');
    if (drawer && !drawer.__springBundleDrawerObs) {
      drawer.__springBundleDrawerObs = true;
      new MutationObserver(function (mutations) {
        for (var m = 0; m < mutations.length; m++) {
          if (mutations[m].attributeName === 'class') {
            setTimeout(injectBundleNote, 100);
          }
        }
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
    document.addEventListener('ajaxProduct:added', function () {
      setTimeout(injectBundleNote, 300);
    });
    setTimeout(injectBundleNote, 500);
  }

  /* ---- INIT ---- */

  function init() {
    if (isOnSpringLP()) {
      stashSpringFlag();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', tagSpringLPLinks);
      } else {
        tagSpringLPLinks();
      }
      new MutationObserver(function () { tagSpringLPLinks(); })
        .observe(document.body || document.documentElement, { childList: true, subtree: true });
    }
    if (isOnPDP()) {
      pdpInit();
    }
    if (isOnCart()) {
      cartGuard();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeBundleNote);
    } else {
      observeBundleNote();
    }
  }

  init();
})();

